import {
  Form,
  Button,
  Select,
  EllipsisSpan,
  Input,
  Paging,
  Table,
  useBreadcrumbRoutes,
  usePaging,
  Wrapper,
  CustomFilter,
  TreeSelect,
} from '@maxtropy/components';
import { CircuitType, CircuitTypeFormat } from '@/api/circuit';
import { SwitchStateDisplay, SwitchState } from '../../utils';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import {
  apiV2PowerRoomConfigCircuitSwitchStatusUpdatePagePost,
  apiV2DistributionCabinetRoomCabinetTreePost,
  V2PowerRoomConfigCircuitSwitchStatusUpdatePagePostResponse,
  V2DistributionCabinetRoomCabinetTreePostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { useNavigate } from 'react-router-dom';
const CircuitTypeOptions = Object.entries(CircuitTypeFormat).map(i => ({
  label: i[1],
  value: Number(i[0]),
}));
const columns = [
  {
    title: '回路名称',
    dataIndex: 'circuitName',
    width: 180,
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '回路编码',
    dataIndex: 'circuitCode',
    width: 180,
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },

  {
    title: '回路类型',
    dataIndex: 'circuitType',
    width: 180,
    ellipsis: { showTitle: true },
    render: (v: string) => {
      const key = Number(v) as CircuitType;
      return <EllipsisSpan value={CircuitTypeFormat[key] || '--'} />;
    },
  },
  {
    title: '所属站房',
    dataIndex: 'roomName',
    width: 180,
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '控制开关状态',
    dataIndex: 'status',
    width: 180,
    ellipsis: { showTitle: true },
    render: (v: string) => {
      const key = Number(v) as SwitchState;
      return <EllipsisSpan value={SwitchStateDisplay[key]} />;
    },
  },
  {
    title: '最后操作时间',
    dataIndex: 'updateTime',
    width: 180,
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={dayjs(v).format('YYYY-MM-DD HH:mm:ss')} />,
  },
  {
    title: '最后操作人',
    dataIndex: 'operator',
    width: 180,
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
];
enum NodeType {
  ROOM = 0,
  CABINET = 1,
}
type DatasListProps = V2PowerRoomConfigCircuitSwitchStatusUpdatePagePostResponse['list'];
type RoomItem = Exclude<V2DistributionCabinetRoomCabinetTreePostResponse['list'], undefined>[number];
const OperationLog: React.FC = () => {
  const [form] = Form.useForm();
  const pagingInfo = usePaging();
  const navigate = useNavigate();
  const { pageOffset, pageSize, setTotalCount, setPageOffset } = pagingInfo;
  const routesContext = useBreadcrumbRoutes();
  const [datasList, setDatasList] = useState<DatasListProps>();
  const [loading, setLoading] = useState<boolean>(false);
  const [roomTree, setRoomTree] = useState<RoomItem[]>([]);

  useEffect(() => {
    apiV2DistributionCabinetRoomCabinetTreePost({}).then(res => {
      // setTreeData(res.list ?? []);
      const filterNodesByType = (nodes: RoomItem[]): RoomItem[] => {
        if (!nodes) return [];

        return nodes
          .filter(node => node.type === NodeType.ROOM) // 只保留type=0的节点
          .map(node => ({
            ...node,
            title: node.name,
            value: node.id,
            children: filterNodesByType(node.children ?? []), // 递归处理子节点
          }));
      };

      const filteredData = filterNodesByType(res.list ?? []);
      setRoomTree(filteredData);
    });
  }, []);

  useEffect(() => {
    if (form) {
      form
        .validateFields()
        .then(values => {
          fetchData(values);
        })
        .catch(() => {
          fetchData({});
        });
    }
  }, [pageOffset, pageSize]);

  const fetchData = async (params: any) => {
    try {
      setLoading(true);
      const res = await apiV2PowerRoomConfigCircuitSwitchStatusUpdatePagePost({
        ...params,
        page: pageOffset,
        size: pageSize,
      });
      setTotalCount(res.total ?? 0);
      setDatasList(res.list);
    } catch (err) {
      console.error('请求失败:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleFinish = (values: any) => {
    setPageOffset(1);
    fetchData({ ...values, page: 1 });
  };
  const filters = (
    <CustomFilter
      form={form}
      onFinish={handleFinish}
      onReset={() => {
        setPageOffset(1);
        fetchData({ page: 1 });
      }}
    >
      <Form.Item name="nameOrCode" label="编号/名称">
        <Input placeholder={'请输入编号或名称查询'} />
      </Form.Item>
      <Form.Item name="circuitType" label="回路类型">
        <Select placeholder="请选择" showSearch allowClear options={CircuitTypeOptions} />
      </Form.Item>
      <Form.Item label="所属站房" name="roomId">
        <TreeSelect
          treeData={roomTree}
          allowClear
          treeDefaultExpandAll
          showSearch
          treeNodeFilterProp="title"
          placeholder="请选择"
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
        />
      </Form.Item>
    </CustomFilter>
  );

  return (
    <>
      <Wrapper routes={routesContext?.routes ?? []} filters={filters}>
        <Table sticky rowKey="id" scroll={{ x: 1500 }} columns={columns} dataSource={datasList} loading={loading} />
        <Paging pagingInfo={pagingInfo} />
        <Button
          style={{ marginTop: 32 }}
          onClick={() => {
            navigate(-1);
          }}
        >
          返回
        </Button>
      </Wrapper>
    </>
  );
};

export default OperationLog;
